import { gql } from "@apollo/client";

const STUDENT_CONFIRM_REGISTRATION_WITH_TOKEN = gql`
  mutation StudentConfirmRegistrationWithToken($confirmationToken: String!) {
    studentConfirmRegistrationWithToken(confirmationToken: $confirmationToken) {
      credentials {
        client
        tokenType
        accessToken
      }
    }
  }
`;

export default STUDENT_CONFIRM_REGISTRATION_WITH_TOKEN;
